<template>
  <el-scrollbar class="scrollbar">
      <div class="sidebar-con" >
        <div class="logo">
          <img :src="$store.getters.logo || defaultLogo" alt="大营家logo" />
        </div>
        
        <el-menu
          :default-active="activeMenu"
          :collapse="isCollapse"
          :unique-opened="true"
        >
          <sidebar-item
            v-for="route in permissionRoutes"
            :key="route.path"
            :item="route"
            :base-path="route.path"
          ></sidebar-item>

          <el-menu-item v-if="$store.state.window_width <= 768"  @click="logout"><el-icon><SwitchButton /></el-icon> 退出</el-menu-item>
        </el-menu>
      <slot />
    </div>
  </el-scrollbar>
</template>

<script setup>
import { defineProps, computed } from "vue";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import SidebarItem from "./SidebarItem.vue";

defineProps(["isCollapse"])

const router = useRouter();
const route = useRoute();
const store = useStore();

const defaultLogo = require("@/assets/images/logo.png")

const permissionRoutes = computed(() => {
  return store.getters['permissionRoutes'];
});

const activeMenu = computed(()=>{
  const { meta, path } = route;
  if (meta.activeMenu) {
      return meta.activeMenu;
    }
    return path;
})

async function logout() {
  await store.dispatch("user/logout");
  router.push(`/login?redirect=${route.fullPath}`);
}
</script>

<style lang="less" scoped></style>
